// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2qwRW","amount":"Amount_amount__2gn0w","tip":"Amount_tip__3q2EF","tipHeader":"Amount_tipHeader__3slq7","tipsWrap":"Amount_tipsWrap__28v5R"};